"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var validator_1 = __importDefault(require("validator"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Telemetry_1 = require("@CommonFrontend/Public/Telemetry/Telemetry");
var ValidateStrings_1 = require("@CommonFrontendBackend/Utils/ValidateStrings");
var c = (0, BemBuilder_1.default)("collaborator-invite-modal");
function RequestQwilrInviteForm(_a) {
    var openConfirmModal = _a.openConfirmModal, closeAllModal = _a.closeAllModal, backCommentModal = _a.backCommentModal, publicApiBaseUrl = _a.publicApiBaseUrl;
    var telemetry = Telemetry_1.Telemetry.getInstance();
    function sendInviteRequest(values) {
        return __awaiter(this, void 0, Promise, function () {
            var collaboratorLinkHash, payload, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        collaboratorLinkHash = window.location.pathname.split("/")[3];
                        payload = {
                            collaboratorLinkHash: collaboratorLinkHash,
                            requesterEmail: values["email"],
                            requesterName: values["name"],
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post("".concat(publicApiBaseUrl, "/request-admin-invite"), payload)];
                    case 2:
                        _a.sent();
                        openConfirmModal();
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [2, (0, kaleidoscope_2.createFormSubmitErrorObject)("We're having trouble submitting your response. Please try again later.")];
                    case 4: return [2];
                }
            });
        });
    }
    return (react_1.default.createElement("div", { onClick: function () {
            closeAllModal();
        } },
        react_1.default.createElement(ModalComponent_1.Modal, { className: c() },
            react_1.default.createElement("div", { className: "confirm-modal" },
                react_1.default.createElement("img", { className: c("image"), src: "/Public/Assets/Images/details.png", alt: "An admin inviting a new user to the Qwilr dashboard" }),
                react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "3", className: c("heading") }, "Enter your details below"),
                react_1.default.createElement(kaleidoscope_2.FormComponent, { onSubmit: sendInviteRequest },
                    react_1.default.createElement(kaleidoscope_2.FormContext.Consumer, null, function () { return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: "name", label: "Name", className: c("input-field"), validate: function (value) {
                                if (!value) {
                                    return "Please enter your name";
                                }
                                var validationResult = (0, ValidateStrings_1.checkBasicText)(value);
                                if (validationResult.valid === false) {
                                    return "Name ".concat(validationResult.error);
                                }
                            } }),
                        react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: "email", label: "Email", placeholder: "you@gmail.com", className: c("input-field"), validate: function (value) {
                                if (!value) {
                                    return "Please enter your email";
                                }
                                var validationResult = (0, ValidateStrings_1.checkBasicText)(value, { allowUrlsOrEmails: true });
                                if (validationResult.valid === false) {
                                    return "Email ".concat(validationResult.error);
                                }
                                if (!validator_1.default.isEmail(value)) {
                                    return "Please enter a valid email";
                                }
                            } }),
                        react_1.default.createElement("div", { className: c("buttons") },
                            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Large, className: c("submit-button"), onClick: function () {
                                    backCommentModal();
                                } }, "Back"),
                            react_1.default.createElement(kaleidoscope_2.FormSubmitButton, { className: c("submit-button") },
                                react_1.default.createElement("span", null, "Send Request"))))); }))))));
}
exports.default = RequestQwilrInviteForm;
